import TextField from '../Base/TextField/TextField';
import { useAppContext } from '../../Services/AppContext';
import { joinClasses } from '../../Utils/className.util';
import React, { useState } from 'react';

function SearchMD({ forwardRef, ...props }) {
	const {
		resultContent,
		handleSearch,
		placeholder,
		marginTop = null,
		changeButton = null,
		changeText = null,
	} = props;
	const { translation } = useAppContext();
	const [typingTimeout, setTypingTimeout] = useState(null);

	const handleOnChange = e => {
		if (typingTimeout) {
			clearTimeout(typingTimeout);
		}

		setTypingTimeout(
			setTimeout(() => {
				handleSearch?.(e.target.value);
			}, props.bounce || 0),
		);
	};

	return (
		<>
			<div
				className={joinClasses([
					'input-group input-with-button-group__input-wrapper',
					'w-100',
				])}
				style={{ marginTop: marginTop }}>
				<input
					ref={forwardRef}
					onChange={handleOnChange}
					placeholder={placeholder}
					bounce={350}
					className='form-control input-with-button-group__input-wrapper__input case-forwarder-button active'
				/>
				{changeButton && (
					<a
						onClick={changeButton}
						href='#'
						className='btn btn-outline-secondary input-with-button-group__input-wrapper__button px-2 case-forwarder-button__change'>
						{changeText || translation['base.change']}
					</a>
				)}
			</div>
			{resultContent && (
				<div
					className={
						'search-user-wrapper-naked__result-wrapper__bg result-absolute'
					}>
					{resultContent}
				</div>
			)}
		</>
	);
}

export default React.forwardRef((props, ref) => (
	<SearchMD {...props} forwardRef={ref} />
));
